import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import * as yup from "yup";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import { getAllState, resetState } from "../../Redux/StateSlice/stateSlice";
import {
    editUtility,
    getAllUtility,
    getSingleUtility,
    reset,
} from "../../Redux/UtilityProviders/UtilitySlice";

const EditUtility = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    useEffect(() => {
        const GetSingleUtility = async () => {
            await dispatch(getSingleUtility(id));
            await dispatch(reset());
        };
        GetSingleUtility();
        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();
    }, []);

    // get all state
    const { states, isStatesloading } = useSelector((state) => state.AllStates);
    const AllStates = states?.data?.states;

    const { singleUtility } = useSelector((state) => state.utility_providers);
    const Single_Utility = singleUtility?.data;

    // console.log(Single_Utility, 'Single_Utility');

    const formik = useFormik({
        initialValues: {
            title: "",
            rate: "",
            annual_increase_percentage: "",
            meter_rate: "",
            rebates: "",
            discounted_rate: "",
            state_id: "",
        },
        // validationSchema,
        onSubmit: async (values) => {
            const formData = new FormData();
            formData.append("_method", "PUT");
            formData.append("title", values.title);
            formData.append("rate", values.rate);
            formData.append(
                "annual_increase_percentage",
                values.annual_increase_percentage
            );
            formData.append("meter_rate", values.meter_rate);
            formData.append("rebates", values.rebates);
            formData.append("discounted_rate", values.discounted_rate);
            formData.append("state_id", values.state_id);
            formData.append("utility_provider_id", id);

            await dispatch(editUtility(formData));
            await dispatch(reset());
            await dispatch(getAllUtility());
        },
    });

    useEffect(() => {
        formik.values.title = Single_Utility?.title;
        formik.values.rate = Single_Utility?.rate;
        formik.values.annual_increase_percentage =
            Single_Utility?.annual_increase_percentage;
        formik.values.meter_rate = Single_Utility?.meter_rate
            ? Single_Utility?.meter_rate
            : 0;
        formik.values.rebates = Single_Utility?.rebates
            ? Single_Utility?.rebates
            : 0;
        formik.values.discounted_rate = Single_Utility?.discounted_rate
            ? Single_Utility?.discounted_rate
            : 0;
        formik.values.state_id = Single_Utility?.state_id;
    }, [Single_Utility]);

    const { isError, isSuccess, isLodaing, massage, isSingleSuccess } =
        useSelector((state) => state.utility_providers);

    useEffect(() => {
        if (isError) {
            toast.error(massage);
        }
        if (isSingleSuccess) {
            toast.success(" Utility Updated  sucessfully ");
        }
        dispatch(reset());
    }, [dispatch, isSuccess, isError, massage, AllStates]);

    return (
        <>
            {isStatesloading && <LoadingAnimation />}
            {!isStatesloading && (
                <FormContainer>
                    <FormHeading>Edit Utility </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="title"
                                    name="title"
                                    label="Title"
                                    value={formik.values.title}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.title &&
                                        Boolean(formik.errors.title)
                                    }
                                    helperText={
                                        formik.touched.title &&
                                        formik.errors.title
                                    }
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="rate"
                                    name="rate"
                                    label="Rate"
                                    value={formik.values.rate}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.rate &&
                                        Boolean(formik.errors.rate)
                                    }
                                    helperText={
                                        formik.touched.rate &&
                                        formik.errors.rate
                                    }
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="annual_increase_percentage"
                                    name="annual_increase_percentage"
                                    label="Annual Increase Percentage"
                                    value={
                                        formik.values.annual_increase_percentage
                                    }
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="meter_rate"
                                    name="meter_rate"
                                    label="meter_rate"
                                    value={formik.values.meter_rate}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="rebates"
                                    name="rebates"
                                    label="rebates"
                                    value={formik.values.rebates}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="discounted_rate"
                                    name="discounted_rate"
                                    label="Discounted Rate"
                                    value={formik.values.discounted_rate}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={12}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        State
                                    </InputLabel>
                                    <Select
                                        id="state_id"
                                        name="state_id"
                                        label="State"
                                        required={true}
                                        value={formik.values.state_id || ""}
                                        onChange={formik.handleChange}
                                    >
                                        {AllStates?.map((key) => (
                                            <MenuItem
                                                key={key.id}
                                                value={key.id}
                                            >
                                                {key.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <PrimaryButton fullWidth type="submit">
                            {isLodaing ? "loading ... " : "Edit Utility"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 4rem;
    margin: 1rem auto;
    background: var(--white);
    box-shadow: 0 5px 8px 0 var(--box-shadow);
    border-radius: 1rem;
    width: 70%;
`;

export default EditUtility;
